import { Typography, Paper, Box, Grid2 as Grid } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import Select from '@/components/Common/Select';
import Input from '@/components/Common/Input';
import TelInput from '@/components/Common/TelInput';
import { useGetTelephonyProviders as useGetTelephonyProvidersProviders } from '@/apis/agency/providers/hook';
import { useGetTelephonyProviders as useGetTelephonyProvidersTelephony } from '@/apis/agency/telephony/hook';

const TelephonyDetailForm = () => {
  const { control } = useFormContext();

  const isPublicForm = typeof window !== 'undefined' && window.location.pathname.includes('/business-onboarding');

  const { data: providersData, isLoading: isProvidersLoading } = useGetTelephonyProvidersProviders(
    { filter: { active_eq: true } },
    { enabled: isPublicForm }
  );

  const { data: telephonyData, isLoading: isTelephonyLoading } = useGetTelephonyProvidersTelephony(
    { filter: { active_eq: true } },
    { enabled: !isPublicForm }
  );

  const providers = isPublicForm ? providersData : telephonyData;
  const isLoading = isPublicForm ? isProvidersLoading : isTelephonyLoading;

  const selectedProvider = useWatch({
    control,
    name: 'current_business_solution.telephony_voip_provider'
  });

  return (
    <Paper
      elevation={0}
      sx={{
        border: '1px solid #EAEAEA',
        borderRadius: 2,
        p: { xs: 2, md: 4 }
      }}
    >
      <Typography fontWeight={600} fontSize={18} mb={0.5}>
        Telephony Details
      </Typography>

      <Typography variant='body2' color='text.secondary' mb={3}>
        How does your phone system connect?
      </Typography>

      <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 6 }}>
          <TelInput
            name='current_business_solution.business_phone_number'
            label='Business Phone Number'
            control={control}
            defaultCountry='US'
            fullWidth
          />
          <Typography color='secondary' fontSize={12}>
            Add the phone number your customers call to react your business.
          </Typography>
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <Select
            name='current_business_solution.telephony_voip_provider'
            label='Telephony/VoIP Provider'
            control={control}
            sortOrder='none'
            fullWidth
            disabled={isLoading}
            options={
              providers?.data
                ? [
                    ...providers.data.map((provider) => ({
                      label: provider.friendly_name,
                      value: provider.code
                    })),
                    { label: 'Other', value: 'Other' }
                  ]
                : []
            }
            helperText='Choose the provider that handles your business phone calls'
          />
        </Grid>

        {selectedProvider === 'Other' && (
          <Grid size={12}>
            <Input
              name='current_business_solution.telephony_service_name'
              label='Telephony Service Name'
              placeholder='Enter Name Here'
              control={control}
              fullWidth
            />
          </Grid>
        )}
      </Grid>

      <Box mt={4}>
        <Typography fontSize={16} fontWeight={600} mb={2}>
          More Information
        </Typography>

        <Input
          name='current_business_solution.configuration.sip_credentials'
          placeholder='Share your provider details, preferred setup, and any available SIP credentials or connection information.'
          control={control}
          multiline
          rows={4}
          fullWidth
          sx={{ mb: 3 }}
        />

        <Box
          sx={{
            background: '#FFFBEB',
            borderRadius: 1,
            p: '16px',
            color: '#D97706',
            fontSize: 14,
            fontWeight: 400,
            mt: 3
          }}
        >
          Whitelist Our SIP Signaling Servers: If you are using SIP trunking, please ensure the following IP addresses
          are allowed through your firewall: <span style={{ textDecoration: 'underline' }}>54.236.168.131:5060</span>
        </Box>
      </Box>
    </Paper>
  );
};

export default TelephonyDetailForm;
